import { IconComponent } from ".";
import Avatar from "../avatar";

const TokenIcon = ({
  tokenName,
  logo,
}: {
  tokenName: string;
  logo: string;
}) => {
  if (tokenName === "ethereum" || tokenName === "solana") {
    return (
      <IconComponent name={tokenName} className="h-[0.9375rem] w-[0.9375rem]" />
    );
  }

  return <Avatar source={logo} />;
};

export default TokenIcon;
